import axiosInst from "./config/axiosConfig";

// delete local deviceData and HashTable
// Will perform a device reboot or a cloud UUID factory reset
export async function changeDeviceStatusFromUI(data) {
  const { eiSerialNumber } = data;
  if (!eiSerialNumber) return null;

  return axiosInst.put("/beta/eiStatusUIHook", { ...data });
}

export async function getDeviceStatus(serialNumber) {
  const response = await axiosInst.get(`/beta/eiStatusUIHook?serialNumber=${serialNumber}`);
  return response.data;
}

export async function getDeviceDirectory(params) {
  const response = await axiosInst.get("/beta/eiStatusUIHook", { params });
  return response.data;
}

export async function deleteDevice(serialNumber) {
  return axiosInst.delete("/beta/devices", {
    params: {
      serialNumber,
    },
  });
}

export async function updateDevice(body) {
  return axiosInst.put("/beta/devices", body);
}

export async function updateVpnDeviceStatus(data, options = {}) {
  return axiosInst.post("/beta/vpnUIHook", { serialNumber: data }, options);
}

export async function disconnectDeviceVpn(serialNumber, options = {}) {
  // requires 'data' object config
  return axiosInst.delete("/beta/vpnUIHook", { ...options, data: { serialNumber } });
}

export async function addSingleDeviceAPIHelper(deviceToAddObj) {
  const deviceObj = { ...deviceToAddObj };
  if (!deviceObj.mac || !deviceObj.serialNumber) {
    return null;
  }

  if (!deviceObj.devicePool) {
    deviceObj.devicePool = "default";
  }

  return axiosInst.post("/beta/devices", { ...deviceObj });
}

export async function bulkUpdateDeviceSoftware(data) {
  const { serialNumbers, updateNow, updateTime } = data;

  if (!serialNumbers || serialNumbers.length === 0) {
    return Promise.reject(new Error("No serial numbers provided"));
  }

  return axiosInst.post("/beta/bulkSwUpdtUIHook", {
    serialNumbers: Array.isArray(serialNumbers) ? serialNumbers.join(",") : serialNumbers,
    updateNow: updateNow.toString(),
    updateTime: updateTime || "",
  });
}

export async function bulkPushDeviceConfig(data) {
  const { serialNumbers, configFileBase64, configFileName, applyNow, scheduleTime, delivery } = data;

  if (!serialNumbers || serialNumbers.length === 0) {
    return Promise.reject(new Error("No serial numbers provided"));
  }

  return axiosInst.post("/beta/bulkConfigPushUIHook", {
    serialNumbers: Array.isArray(serialNumbers) ? serialNumbers.join(",") : serialNumbers,
    configFileBase64,
    configFileName,
    applyNow: applyNow.toString(),
    scheduleTime: scheduleTime || "",
    ...(delivery ? { delivery } : {}),
  });
}
